module.exports = __webpack_public_path__ + "static/media/zoom-out.0d64ad21.svg";